import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import React, { Component } from "react";
import CommonTile from "../CommonTile";
import Footer from "../Footer";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import OurTeamAboutMe from './OurTeamAboutMe';
import Grow from "@mui/material/Grow";

import _ from "lodash";

// Top Marketing
// Strong Negoitaors
// Experiaced Team
// Stagging & Photography
// Resources
// Contact Your Realtor

class OurTeam extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.markers = [];

    this.state = {
      pictureHeight: "100%",
      pictureWidth: "60%",
      parentPage: "OurTeam",
      selectedIndex:0,
      

      our_team: [
        {
          name:"Donna Wills",
          profilepic:"profile-round-lowres.png",
          title:"Licensed Real Estate Salesperson",
          email:"DonnaWills@HowardHanna.com",
          phone:"315 - 723 - 1077",
          testimonials: [
            {
              title: "  Loved Working With Donna",
              summary:
                "I loved working with Donna Wills during my home buying process. She was fun and knowledgeable and always had a positive attitude. Her communication was quick, friendly, and I felt like a priority to her. Highly recommend!",
              name:"Julianna",
            },
            {
              title: "  Donna Is The Best",
              summary:
                "Donna is the best!! As first-time homebuyers, my husband and I were nervous to start our search. But Donna walked us through the process step by step. She created guides and checklists that made comparing homes, submitting an offer, and closing on our home easy. She was always available to answer our questions and give us advice. She truly had our best interests at heart. Donna is a wonderful agent, I can’t recommend her highly enough!",
              name:"Lisa",
            },
            {
              title: "  Donna Was So Helpful",
              summary:
                "Donna was so helpful with our search. She was understanding when we switched our search criteria many times and sent us listings that matched perfectly! She was also always available to us night, day, weekends- you name it. If you want someone reliable , knowledgeable and honest, use her for your next move!",
              name:"Erik",
            },
            {
              title: "  Hard Working",
              summary:
                "Donna always is quick to respond and will never forget to follow up. You would think that she is exclusively yours with your real estate needs, even though you are not haha Obviously, Donna loves what she does.",
              name:"Julie",
            },
            {
              title: "  Above & Beyond",
              summary:
                "After deciding to move across the country We aligned with Donna through an online virtual tour after already having a few tours with other realtors & we knew right away we were meant to be with Donna!",
              name:"Chris & Ashley",
            },
            {
              title: "  Donna Is Amazing",
              summary:
                "Donna is amazing!! She discussed ideas that could enhance my property’s value and went above and beyond with staging the property perfectly and marketing my neighborhood for potential buyers. She earned every penny of her commission which you don’t always see with realtors. And, she was present in the process all the way thru to closing. Highly recommend this gem!",
              name:"Wendy V",
            },
            {
              title: "  Incredibly Smooth",
              summary:
                "The process of selling a home with Donna was incredibly smooth. She not only is incredibly thorough explaining each part of the process, she provided guides for us to understand what came next and while we were moving out, the home looked a little sparse, she ended up bringing in staging furniture so it showed beautifully online! We sold in under one week. We couldn't ask for a better agent!",
              name:"Joe",
            },
            {
              title:"   Glad To Now Call Her A Friend", 
              summary: "Donna went above and beyond to make sure that our family was comfortable and happy during the difficult process of buying and selling! We truly thank her for her time and enthusiasm and are glad to now call her a friend",
              name: "Audrey"
            },
            {
              title:"   Donna Was Great", 
              summary:"Donna was great in helping us find a great home quickly in this crazy market! She went out of her way to do a Zoom showing at 9pm when we were away on what is now our first home. Thank you Donna!",
              name: "Ashley B"   
            },     
            {
            title:"So Very Glad",
            summary: "My husband and I are so very glad that we hired Donna. I originally had a different realtor. He although was nice the first time we met, he seemed to be quiet after.  He was not a good fit for us. Donna was the very exact opposite. She was always with a smile, was so energetic, and so very helpful. She helped stage our house, so that we would get more bids. It worked, as our house went for way more past asking price.",
            name:"Marsha & Tim"
            },
            {
              title: "    Highly Recommend",  
              summary: " She is a “SHARK” That lady is professional in her business. Available 24/7. Always ready to schedule a showing and available to do so any time it works for clients. Either 6 am or 10 pm. Highly recommend!",
              name: "Nelya S"
            },
            {
              title:"    Amazing To Work With",        
              summary:"Donna was amazing to work with. From the beginning to the end of the selling and buying process, Donna was there to advise with any and all questions to help guide us to make the best financial decisions for ourselves. Her knowledge on what to do to get the house picture perfect for the MLS listing as well as for showings was evident. Her detail in staging and wording for the listing was a work of art.",
              name: "Shana M"
            },
            {
              title:"    Great Agent",
              summary:"As a first time homebuyer, Donna made the whole process very easy and exciting. Donna is a great agent and a true expert at what she does. She goes above and beyond what is expected. I highly recommend Donna. She always made herself available whenever I had a question and made sure I was happy.  I am very happy with my experience and I will be working with Donna again in the future.",
              name: "Garth G"
            },
            {
              title:"    Amazing Work Ethic",
              summary:"Donna went above and beyond! She made the home buying process easier then the average agent. She was always available and has AMAZING work ethic. I felt loved and trusted her to find the right home for my family. We could not be happier!!!! Thanks Donna, I will gladly tell my friends and my family who to sign with!",
              name: "Bettina P"
            },
            {
              title:"Donna Was So Patient",
              summary:"As a first time home buyers, my husband and I had many questions. Donna was so patient and able to help us through each question and detail through this process. We went to see so many houses with Donna and she was very flexible with times that worked for us and helped us figure out exactly what we were looking for. I would recommend Donna to anyone looking to buy a home!",
              name:"Erin"
            },
            {
              title:"    There When I Needed Her",
              summary:"Ok so I just want to say Donna wills is amazing!! She was there when I needed her and she answered every question I had to ask.  She deserves so much credit and I don’t know if it can get any better then her she definitely was greatness. It feels like she was a real estate agent sent from heaven. Again really appreciate her and will be using her for my house and rentals from now on.",
              name: "Khiry S"
            },
            {
              title:"    We Were So Impressed",
              summary:"My wife and I's experience with Donna started when she dropped a personalized flier in our mailbox to list our home. We knew we were moving, but had not yet decided to go with another realtor that helped us in the past or look for a new one. We were so impressed with her initiative we called her that night (Sunday). She made time for us that night, spent almost 3 hrs with us and we set a plan to list the home.",
              name: "Jeremy & Erika"
            },
            {
              title:"    Loves What She Does",
              summary: "Donna was a Pleasure to have as our realtor. She was very personable, understanding, hard working, very timely. Donna was alwasy quick to respond and will never forget to follow up.  Donna loves what she does. She always walked that extra mile to make the whole real estate experience with her the best it can be. I cant compliment her and thank her enough! Thank you Donna!",
              name:"Julie & Don"
            },
            {
              title:"    Worked With My Schedule",
              summary:"Donna made the home buying experience as painless as possible. She was extremely responsive, very knowledgable, and worked with my schedule while still being available. I was working on a tight deadline to find a place to move and Donna made sure we met that deadline while also meeting my goals and expectations for a home. I can’t recommend her enough!",
              name:"Anthony B"
            },        
            {
              title:"    Donna is a wonderful agent",
              summary:"Donna is the best!! As first-time homebuyers, my husband and I were nervous to start our search. But Donna walked us through the process step by step. She created guides and checklists that made comparing homes, submitting an offer, and closing on our home easy. She was always available to answer our questions and give us advice. She truly had our best interests at heart. Donna is a wonderful agent, I can’t recommend her highly enough!",
              name:"Lisa",
            },    
          ],
          aboutme:""         
        },
        {
          name:"Roger Nestler",
          profilepic:"profile-round-lowres.png",
          title:"Licensed Real Estate Salesperson",
          email:"RogerNestler@HowardHanna.com",
          phone:"315 - 723 - 1077",
          testimonials:[
            {
              title:"    Donna is a wonderful agent",
              summary:"Donna is the best!! As first-time homebuyers, my husband and I were nervous to start our search. But Donna walked us through the process step by step. She created guides and checklists that made comparing homes, submitting an offer, and closing on our home easy. She was always available to answer our questions and give us advice. She truly had our best interests at heart. Donna is a wonderful agent, I can’t recommend her highly enough!",
              name:"Lisa",
            }    
          ],
          aboutme:""
        },
        {
          name:"Joe Smith",
          profilepic:"profile-round-lowres.png",
          title:"Licensed Real Estate Salesperson",
          email:"JoeSmith@HowardHanna.com",
          phone:"315 - 723 - 1077",
          testimonials:[
            {
              title:"    Donna is a wonderful agent",
              summary:"Donna is the best!! As first-time homebuyers, my husband and I were nervous to start our search. But Donna walked us through the process step by step. She created guides and checklists that made comparing homes, submitting an offer, and closing on our home easy. She was always available to answer our questions and give us advice. She truly had our best interests at heart. Donna is a wonderful agent, I can’t recommend her highly enough!",
              name:"Lisa",
            }    
          ],
          aboutme:""
        },
        {
          name:"Donna Wills",
          profilepic:"profile-round-lowres.png",
          title:"Licensed Real Estate Salesperson",
          email:"@HowardHanna.com",
          phone:"315 - 723 - 1077",
          testimonials:[
            {
              title:"    Donna is a wonderful agent",
              summary:"Donna is the best!! As first-time homebuyers, my husband and I were nervous to start our search. But Donna walked us through the process step by step. She created guides and checklists that made comparing homes, submitting an offer, and closing on our home easy. She was always available to answer our questions and give us advice. She truly had our best interests at heart. Donna is a wonderful agent, I can’t recommend her highly enough!",
              name:"Lisa",
            }    
          ],
          aboutme:""
        }
      ],
      showAboutMe: false,
      subService: "Our Team",            
    }
  }


  componentDidUpdate(prevProps, prevState) {
      if (prevProps.showOurTeam !== this.props.showOurTeam) {
        this.setState({
          showAboutMe: false,
          subService:"Our Team"  
        })
      }
  }


  toggleOurTeam = () => {
    this.setState({
      OurTeam: !this.state.OurTeam,
      subService:"Our Team"
    });
  };

  toggleContactForm = () => {
    this.setState({
      showListing: null,
      contactForm: !this.state.contactForm,
      contactReason: "Lets Connect",
    });
  };

  toggleAboutMe = (profilepic, name, title, phone, email, testimonials, aboutme) => {
    this.setState({
      showAboutMe: !this.state.showAboutMe,
      profilepic: profilepic,
      name: name,
      title: title,
      email: email,
      phone: phone,
      testimonials: testimonials,
      aboutme: aboutme
    })
  }

  downloadResources = (filename) => {
    // Make a request to the server to download the file
    fetch('/' + filename)
      .then(response => {
        // Create a new blob object from the response
        return response.blob();
      })
      .then(blob => {
        // Create a URL for the blob object
        const url = window.URL.createObjectURL(blob);
  
        // Create a new link element
        const link = document.createElement('a');
  
        // Set the link's href attribute to the URL
        link.href = url;
  
        // Set the link's download attribute to the desired file name
        link.download = filename;
  
        // Click the link to initiate the download
        link.click();
  
        // Clean up the URL object
        window.URL.revokeObjectURL(url);
      });
  }


  createSection = (section, title, intro, tileBuilder, outro) => {
    return (
      <Grid
        container
        ref={section}
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          background: "rgba(255,255,255,.7)",
          height: "100%",
          width: "100%",
          borderBottom: "0px solid #333333",
        }}
      >
        
        <Grid
          item
          sx={{
            width: "100%",
            height: {
              xl: "90%",
              lg: "90%",
              md: "88%",
              sm: "90%",
            },
            padding: "0px",
            fontSize: "2rem",
            background:"rgba(255,255,255,0)",
          }}
          xs={12}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              background:"rgba(255,255,255,0)",
              height: "100%",
              width: "100%",
            }}
          >
 
        {this.state.our_team.map((item, index) => (
                        <Grid 
                          item
                          sx={{
                            padding: "0px",
                            height: {
                              sm: "100%",
                            },
                            borderBottom:"0px solid #CCCCCC",
                            textAlign:"center"
                          }}
                          xs={12}
                          md={3}
                          >
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              fontWeight: "normal",
                              width: "100%",
                              height: "100%",
                            }}
                          >

            {this.makeTeamMemberCard(item.profilepic, item.name, item.title, item.email, item.phone, item.testimonials, item.aboutme)}


                        </Grid>
                        </Grid>
        ))}
            

            
          </Grid>



        </Grid>
        <Grid
          item
          sx={{
            width: "100%",
            height: {
              xl: "10%",
              lg: "10%",
              md: "12%",
              sm: "10%",
            },
            padding: "5px",
            fontSize: "2rem",
            background:"rgba(255,255,255,.7)",
            
          }}
          xs={12}
        >
           <Footer theme={this.props.theme}  />
        </Grid>
      </Grid>
    );
  };


makeTeamMemberCard = (profilepic, name, title, email, phone, testimonials = [], aboutme = "") => {

return(
  <Grow in={true} timeout={4000}>
  <Grid
    item
    sx={{
      textAlign: "center",
      fontWeight: "bold",
      border: "0px solid blue",
      height: {
        xs: "100%",
      },
                    
      padding:{
        xs: "0px",

      }
    }}
    xs={12}
  >

      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-start"
        sx={{
          padding: {
            xs: "0px 0px 0px 0px",
            
          },
          border:"0px solid red",
          width: {
            xl: "100%",
            lg: "100%",
            md: "100%",
            sm: "100%",
          },
          height: {
            xl: "100%",
            lg: "100%",
            md: "100%",
            sm: "100%",
            xs: "100%",
          },
        }}
        >
            <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            sx={{
              height: {
                xs: "100%",
              },
              border:{
                xs:"0px solid black",
                sm:"0px solid black",
                md:"0px solid #333333",
                lg:"0px solid #333333",
                xl:"0px solid #333333"
              },
                fontWeight: "normal",
                padding: {
                  xs: "0px 0px 0px 0px",
                  sm: "10px 10px 5px 10px",
                  md: "0px 0px 5px 0px",
                  lg: "0px 0px 0px 0px",
                  xl: "0px 0px 5px 0px"
                },
                background:"rgba(255,255,255,.7)",
                borderRadius:"0px"
                  
            }}
            ref={this.containerRef}
            >
               
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    width: {
                      xs: "100%",
                    },
                    height: {
                      xs: "100%",
                    },
                    padding:"0px",
                    border:"0px solid orange",
                    borderRadius:"0px"
                  }}
                  >
                      <Grid
                        item
                        sx={{
                          paddingTop: {
                            xs:"5px",
                            sm:"0px",
                            md:"5px",
                            lg:"5px",
                            xl:"10px",
                          },    
                          fontWeight:"bold",
                          textAlign: "center",
                          fontSize: {
                            xs: "1.5rem",
                            sm: "1.5rem",
                            md: "2.25rem",
                            lg: "2.25rem",
                            xl: "2.5rem",
                          },
                        height: {
                            xs: "20%",
                            sm: "20%",
                            md: "10%",
                            lg: "10%",
                            xl: "10%",
                          },
                          border:"0px solid black",
                          color: this.props.theme.textColor
                        }}
                        xs={8}
                        md={12}

                      >
                          {name}
                      </Grid> 
                      <Grid
                          item
                          sx={{
                            padding: {
                              xs:"10px 0px 5px 0px",
                              sm:"0px",
                              md:"0px",
                              lg:"0px",
                              xl:"0px",
                            },    
                            textAlign: "center",
                            border:"0px solid black",
                            fontSize: {
                              xs: ".8rem",
                              sm: ".8rem",
                              md: "1rem",
                              lg: "1rem",
                              xl: "1rem",
                            },
                            
                          height: {
                              xs: "10%",
                              sm: "10%",
                              md: "10%",
                              lg: "10%",
                              xl: "10%",
                            },
                            color: this.props.theme.textColor
                          }}
                          xs={2}
                          md={2}
                        >
                        </Grid> 

                        <Grid
                          item
                          sx={{
                            "&:hover": {
                              cursor: "pointer",
                            },
                            padding: {
                              lg:"2px 5px 2px 5px",
                            },    
                            textAlign: "center",
                            border:"0px solid black",
                            fontSize: {
                              xs: ".8rem",
                              sm: ".8rem",
                              md: ".8rem",
                              lg: "1rem",
                              xl: "1rem",
                            },
                            
                          height: {
                              xs: "10%",
                              sm: "10%",
                              md: "5%",
                              lg: "5%",
                              xl: "5%",
                            },
                            borderRight: "2px solid " + this.props.theme.bannerTextColor,
                            color: this.props.theme.bannerTextColor,
                            background: this.props.theme.bannerColor,
                            borderTopLeftRadius: "20px",
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                            borderBottomLeftRadius: "20px",
                    
                          }}
                          xs={4}
                          md={4}
                          onClick = { () => this.toggleAboutMe(profilepic, name, title, email, phone, testimonials, aboutme)}

                        >
                            <Grid
                              container
                              direction="row"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                fontWeight: "normal",
                                width: "100%",
                                height: "100%",
                              }}
                            >
                            About Me
                            </Grid> 
                        </Grid> 
                        <Grid
                          item
                          sx={{
                            "&:hover": {
                              cursor: "pointer",
                            },
                            padding: {
                              lg:"2px 5px 2px 5px",
                            },    
                            textAlign: "center",
                            border:"0px solid black",
                            fontSize: {
                              xs: ".8rem",
                              sm: ".8rem",
                              md: ".8rem",
                              lg: "1rem",
                              xl: "1rem",
                            },
                            
                          height: {
                              xs: "10%",
                              sm: "10%",
                              md: "5%",
                              lg: "5%",
                              xl: "5%",
                            },
                            color: this.props.theme.bannerTextColor,
                            background: this.props.theme.bannerColor,
                            borderTopLeftRadius: "0px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            borderBottomLeftRadius: "0px",
                          }}
                          xs={4}
                          md={4}
                            onClick={() => this.props.showContact("OurTeam", profilepic, name, title, email, phone)}

                        >
                            <Grid
                              container
                              direction="row"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                fontWeight: "normal",
                                width: "100%",
                                height: "100%",
                              }}
                            >
                           Contact Me
                           </Grid> 

                        </Grid> 
                        <Grid
                          item
                          sx={{
                            padding: {
                              xs:"10px 0px 5px 0px",
                              sm:"0px",
                              md:"0px",
                              lg:"0px",
                              xl:"0px",
                            },    
                            textAlign: "center",
                            border:"0px solid black",
                            fontSize: {
                              xs: ".8rem",
                              sm: ".8rem",
                              md: "1rem",
                              lg: "1rem",
                              xl: "1rem",
                            },
                            
                          height: {
                              xs: "10%",
                              sm: "10%",
                              md: "10%",
                              lg: "10%",
                              xl: "10%",
                            },
                            color: this.props.theme.textColor
                          }}
                          xs={2}
                          md={2}
                        >
                        </Grid> 

                        <Grid
                          item
                          sx={{
                            padding: "0px",
                            textAlign: "center",
                            fontSize: {
                              xs: "0rem",
                              sm: "0rem",
                              md: "2.5rem",
                              lg: "3rem",
                              xl: "3rem",
                            },
                            width:"100%",
                            height: {
                              xs: "0px",
                              sm: "0px",
                              md: "50%",
                              lg: "60%",
                              xl: "60%",
                            },

                          }}
                          xs={8}
                          lg={12}
                          >

                            <Grid
                              container
                              direction="row"
                              justifyContent="flex-end"
                              alignItems="flex-end"
                              sx={{
                                fontWeight: "normal",
                                width: "100%",
                                height: "100%",
                                backgroundImage: 'url("profilepics/' + profilepic + '")',
                                backgroundPosition: "50% 100%",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                              }}
                            >
                            </Grid>
                        </Grid> 

                        <Grid
                            item
                            sx={{
                              padding: "0px",
                              textAlign: "center",
                              fontSize: "1rem",
                              height: {
                                xs: "65%",
                                sm: "65%",
                                md: "10%",
                                lg: "10%",
                                xl: "10%",
                              },
                            }}
                            xs={8}
                            md={12}
                         >
                              <Grid
                                  container
                                  direction="row"
                                  justifyContent="center"
                                  alignItems="flex-start"
                                  sx={{
                                    cursor: "pointer",
                                    width: "100%",
                                    height: "100%",
                                    padding: {
                                      xs:"10px",
                                      sm:"30px",
                                      md:"10px",
                                      lg:"10px",
                                      xl:"10px",
                                    },    
                                    fontWeight: "bold",
                                    border:"0px solid red",
                                    lineHeight: {
                                      xs: "1.5",
                                      sm: "1.5",
                                      md: "1.5",
                                      lg: "1.5",
                                      xl: "1.5",
                                    },
                                    fontSize: {
                                      xs: ".7rem",
                                      sm: ".7rem",
                                      md: ".8rem",
                                      lg: "1rem",
                                      xl: "1rem",
                                    },
                                    color:this.props.theme.textColor
                                  }}
                                >
                                  {title}
                                  <br />
                                  {email}
                                  <br />
                                  {phone}
                                </Grid>

                        </Grid>                                
                        <Grid
                                item
                                sx={{
                                  marginTop: "10px",
                                  textAlign: "center",
                                  fontSize: ".8rem",
                                  height: "10%",
                                  border:"0px solid red",
                                  lineHeight: "1.5",

                                }}
                                
                                xs={12}
                            >
                              
                        </Grid>                                

              </Grid>
             

        </Grid>

        </Grid>
      </Grid>
    </Grow>
)


}


  nextSlide = () => {
    
    if(this.state.testimonialTiles && (this.state.testimonialTiles.length > 0 )){
      if(this.state.selectedIndex+1 < (this.state.testimonialTiles.length)){
        this.setState({
          selectedIndex: this.state.selectedIndex+1
        })
      }else{
        this.setState({
          selectedIndex: 0
        })
      }
    }
  }

  previousSlide = () => {
    if(this.state.testimonialTiles && this.state.testimonialTiles.length > 0){
      if(this.state.selectedIndex > 0){
        this.setState({
          selectedIndex: this.state.selectedIndex-1
        })
      }else{
        this.setState({
          selectedIndex: this.state.testimonialTiles.length-1
        })
      }
    }
  }


  
  render() {

 
    return (
      <React.Fragment>
      <Drawer
          anchor="bottom"
          open={this.props.showOurTeam}
          onClose={this.props.toggleOurTeam}
          ModalProps={{
            // Setting this prop to false will create a non-modal drawer
            hideBackdrop: true,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            // Setting this prop to false will create a non-modal drawer
            disablePortal: true,
          }}
          variant="persistent"
          PaperProps={{
            sx: {
              backgroundImage: "url('"+ this.props.theme.background +"')",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
                  height: {
                xs: "86%",
                sm: "85%",
                md: "90%",
                lg: "90%",
                xl: "90%",
              },
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
              },
              marginLeft: "auto",
              pointerEvents:"auto",
              border: "0px solid gray"
            },
          }}
        >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: {
            xs: "100%",
          },
          width: {
            xs: "100%",
          },
          
          borderTop:{
            xs:"0px solid #AAAAAA",
            sm: "0px solid #333333"
          }
        }}
      >

      <Grid
            item
            sx={{
              background: this.props.theme.bannerColor,
              cursor: "pointer",
              textAlign: "left",
              padding: "5px",
              borderBottom: "0px solid #A0A0A0",
              fontWeight: "bold",
              fontSize: {
                xs: "0px",
                sm: "0px",
                md: "1rem",
                lg: "1rem",
                xl: "1.5rem",
              },
              height: {
                xs: "12%",
                sm: "12%",
                md: "12%",
                lg: "12%",
                xl: "12%",
              },
            }}
            xs={4}
            md={6}
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{
                height: "100%",
                width: { md: "100%", xs: "100%" },
                padding: "0px 0px 0px 5px",
                fontSize:{
                  xs:"1rem",
                  sm:"1rem",
                  md:"1.5rem",
                  lg:"1.5rem",
                  xl:"1.5rem",
                },             
                color:this.props.theme.bannerTextColor  
              }}
            >
            {this.state.subService}
            </Grid>
          </Grid>
          <Grid
            item
            sx={{
              background: this.props.theme.bannerColor,
              cursor: "pointer",
              textAlign: "center",
              padding: "10px",
              borderBottom: "0px solid #A0A0A0",
              fontWeight: "bold",
              height: {
                xs: "12%",
                sm: "12%",
                md: "12%",
                lg: "12%",
                xl: "12%",
              },
            }}
            xs={8}
            md={6}
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                height: "100%",
                width: { md: "100%", xs: "100%" },
                paddingBottom: "0px",
              }}
            >
              <Button
                onClick={() => this.props.showContact("OurTeam")}
                variant={this.props.theme.buttonVariant}
                sx={{
                  '&:hover': {
                    border:"1px solid " + this.props.theme.buttonTextColor,
                    background:this.props.theme.buttonHoverColor
                  },
      
                  marginRight: "5px",
                  borderTopLeftRadius: "20px",
                  borderTopRightRadius: "0px",
                  borderBottomRightRadius: "0px",
                  borderBottomLeftRadius: "20px",
                  textTransform: "none",
                  textAlign: "center",
                  fontSize:{
                    xs:".75rem",
                    sm:".75rem",
                    md:".75rem",
                    lg:"1rem",
                    xl:"1rem"
                  },
                  color:this.props.theme.buttonTextColor,
                  border:"1px solid " + this.props.theme.buttonColor,
                }}
              >
                Contact Donna
              </Button>



              <Button
                onClick={this.toggleOurTeam}
                variant={this.props.theme.buttonVariant}
                sx={{
                  '&:hover': {
                    border:"1px solid " + this.props.theme.buttonTextColor,
                    background:this.props.theme.buttonHoverColor
                  },
      
                  marginRight: "0px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "20px",
                  borderBottomRightRadius: "20px",
                  borderBottomLeftRadius: "0px",
                  textTransform: "none",
                  textAlign: "center",
                  fontSize:{
                    xs:".75rem",
                    sm:".75rem",
                    md:".75rem",
                    lg:"1rem",
                    xl:"1rem"
                  },
                  color:this.props.theme.buttonTextColor,
                  border:"1px solid " + this.props.theme.buttonColor,
                }}
              >
                Close
              </Button>
            </Grid>
          </Grid>        
            <Grid
              item
              sx={{
                padding: "0px",
                height: {
                  xl: "88%",
                  lg: "88%",
                  md: "88%",
                  sm: "88%",
                },
                overflowY: "auto",
                overflowX: "hidden",
                fontSize: "16px",
                border: "0px solid red",
                
              }}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{
                  height: "100%",
                  
                  border: "0px solid #333333",
                }}
              >   

                {this.createSection(
                this.OurTeamAboutMeSection,
                "Howard Hanna Advantage",
                " When it comes to real estate, it's important to work with the best and we're the top OurTeamAboutMeage in the area. With a proven track record of success, we're committed to providing you with the highest level of service.",
                null,
                "When you choose to work with us, you can be confident that you're getting the best of the best."
              )}
            </Grid>
        </Grid>

      </Grid>

      </Drawer>
      
            <OurTeamAboutMe
              parentPage={this.state.parentPage}
              showAboutMe={this.state.showAboutMe}
              toggleAboutMe={this.toggleAboutMe}
              showContact={this.props.showContact}
              downloadResource={this.props.downloadResource}
              theme={this.props.theme}
              profilepic={this.state.profilepic}
              name={this.state.name}
              title={this.state.title}
              email={this.state.email}
              phone={this.state.phone}
              testimonials={this.state.testimonials}
              aboutme={this.state.aboutme}

            />

             
        </React.Fragment>          
    );
  }
}

export default OurTeam;
